<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">

    <div class="col-lg-2 col-md-12 col-12">
      <div class="card">
        <div class="card-header">
          <h5>Filter</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 col-md-3 col-6 form-group">
              <label class="form-label">Status</label>
              <ng-multiselect-dropdown
              [placeholder]="'--status--'"
              [settings]="dropdownSettingsStatus"
              [data]="dropdownListStatus"
              [(ngModel)]="selectedItemsStatus"
              (onSelect)="onItemSelect($event)"
              (onSelectAll)="onSelectAll($event)"
              >
              </ng-multiselect-dropdown>
            </div>

            <div class="col-lg-12 col-md-3 col-6 form-group">
              <label class="form-label">Publisher</label>
              <ng-multiselect-dropdown
              name="publisher"
              [placeholder]="'--publisher--'"
              [settings]="dropdownSettingsPublisher"
              [data]="dropdownListPublisher"
              [(ngModel)]="selectedItemsPublisher"
              (onSelect)="onItemSelectPublisher($event)"
              (onSelectAll)="onSelectAllPublisher($event)"
              >
              </ng-multiselect-dropdown>
            </div>

            <div class="col-lg-12 col-md-3 col-6 form-group">
              <label class="form-label">Start date</label>
              <input class="form-control" type="date"  max="{{this.DateMax}}" [(ngModel)]="fromDate">
            </div>
            <div class="col-lg-12 col-md-3 col-6 form-group">
              <label class="form-label">End  date</label>
              <input class="form-control digits" type="date"  max="{{this.DateMax}}" [(ngModel)]="toDate">
            </div>
          </div>

            <div class="form-group align-items-center">
              <button class="btn btn-pill btn-sm {{btnColor}}" type="button" placement="top" ngbTooltip="apply filter" (click)="onFilter()" name="btnFilter">
              {{btnName}}</button>
              <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="clear filter" (click)="onClear()" name="btnClear">
                Clear</button>
              </div>
          </div>

      </div>
    </div>

    <div class="col-lg-10 col-md-12 col-12">
      <div class="card">
        <div class="card-body custom-datatable">
          <ngx-datatable
          class='bootstrap'
          [rows]="conversionData"
          [columnMode]="ColumnMode.flex"
          [externalPaging]="true"
          [count]="page.totalElements"
          [offset]="page.pageNumber"
          [limit]="page.size"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          (page)="setPage($event)"
          [sorts]="[{prop: 'dateUtc', dir: 'desc'}]"
          >
          <ngx-datatable-column name="Publisher" [flexGrow]="1" prop="publisher.firstName">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Publisher</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a href="adm/publishers/{{ row.publisher.id }}">{{ row.publisher.firstName }} {{row.publisher.lastName}}</a>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="dateUtc" [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Date</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.dateUtc | date : 'dd-MM-yyyy HH:mm' }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Status" [flexGrow]="1" prop="conversationStatus.name">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Status</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div *ngIf="row.conversationStatus.name=='Pending'">
                <span class="badge badge-warning">Pending</span>
              </div>
              <div *ngIf="row.conversationStatus.name=='Paid'">
                Paid
              </div>
              <div *ngIf="row.conversationStatus.name=='Reverted'">
                <span class="badge badge-danger">Reverted</span>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Revenue" [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Payout</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.revenue | currency }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Visitor" [flexGrow]="1" prop="visitorCountry.name">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Visitor</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <i class="flag-icon flag-icon-{{row.visitorCountry.alpha2Code | lowercase}}" ></i>&nbsp;
              {{ row.visitorCountry.name }} <small> <b>IP:</b>{{row.visitorIP}}</small>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="referer" [flexGrow]="2">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Referrer</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a href="{{ row.referer }}">{{ row.referer }}</a>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="offerName" [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Offer</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a href="adm/offers/{{ row.offerId }}">{{ row.offerName }}</a>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
        </div>
      </div>
    </div>

  </div>
</div>
<!-- Container-fluid Ends-->
